module.exports = __webpack_public_path__ + "media/images/help/resulted_race_sample_payload-5d265275b7a4f632a774c274f82bf6ff.png";